import { useCallback, useEffect } from "react"
import fetchClientLifeSentence from "./fetchClientLifeSentence"
import { pipe } from "fp-ts/lib/function"
import * as E from "fp-ts/Either"
import { useLifeStore } from "./useLifeStore"
import { hasAccessToken } from "@/utils/cookieUtils"

const useLifeSentence = (enabled: boolean = true) => {
  const { setLifeSentenceData, isLifeSentence, clearLifeSentence } =
    useLifeStore()
  const fetch = useCallback(async () => {
    clearLifeSentence()
    const result = await fetchClientLifeSentence()
    pipe(
      result,
      E.match(
        () => {},
        (v) => {
          // v가 배열이면 첫 번째 요소를, 단일 객체면 그대로 저장
          const sentence = Array.isArray(v) ? v[0] : v
          setLifeSentenceData(sentence || null)
        },
      ),
    )
  }, [clearLifeSentence, setLifeSentenceData])
  useEffect(() => {
    if (!enabled) return
    if (hasAccessToken()) fetch()
  }, [enabled, fetch])
  return { fetch, isLifeSentence, clearLifeSentence }
}

export default useLifeSentence
